import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Input } from '../../../../components/ModalInputs'
import { OrderContext } from '../../../../utils/context'
import moment from 'moment'
import CustomSelect from '../../../../components/CustomSelect'
import { arrayForSelect } from '../../../../utils/arrayForSelect'
import { getStudents } from '../../../../actions/students/list'


export default function Expulsion() {

  const dispatch = useDispatch()

  const { values, personnelList, setFieldValue, handleChange, specFields } = useContext(OrderContext)
  const { list } = useSelector(state => state.students)
  const { studentList } = list || {}

  const [selected, setSelected] = useState(null)

  useEffect(() => {
    dispatch(getStudents({ status: 'all' }))
  }, [])

  const dateClass = (name, data) => {
    setSelected(list && list?.find(item => item.mid == data))
    setFieldValue(name, data)
  }

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <CustomSelect
              title='ФИО'
              valuesName="mid"
              options={arrayForSelect(list, 'fio', 'mid')}
              value={list && list?.find(item => item.mid == values.mid)?.fio}
              setFieldValue={dateClass}
              withoutAll
              width={300}
            />
          </div>
          <p>Дата рождения: {selected?.birthday}  </p>
          <p>Класс {selected?.school_class}</p>
          <div className={styles.inputsRow}>
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='Дата отчисления'
              name='date'
              value={moment(values.date).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Причина'
              name='string'
              value={values.string}
              // error={error('string')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Основание'
              name='string2'
              value={values.string2}
              // error={error('string2')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='Исключить из списков и всех видов обеспечечения с'
              name='date2'
              value={moment(values.date2).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='№ приказа'
              name='string4'
              value={values.string4}
              // error={error('string4')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Протокол педсовета №'
              name='string3'
              value={values.string3}
              // error={error('string3')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='от'
              name='date3'
              value={moment(values.date3).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
          </div>
        </div>
      </div >

    </>
  )
}
